import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  MDBBtn,
  MDBSpinner,
  MDBIcon,
  MDBContainer,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";
import PreHeader from "../Home/PreHeader";
import Tabs from "./Tabs";
import AppBuildVersion from "../AppBuildVersion/AppBuildVersion";
import PrintableBillDetails from "./PrintableBillDetails";

const BillDetails = () => {
  const { sessionId, id } = useParams();
  const location = useLocation();
  const [bill, setBill] = useState({});
  const [ordinal, setOrdinal] = useState(0);
  const [isPrintReady, setIsPrintReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const query = new URLSearchParams(location.search);
  const openTab = query.get("open_tab") || "Summary";

  const componentRef = useRef();

  useEffect(() => {
    async function fetchDataAndSetBills() {
      try {
        const { data: billData } = await axios.get(
          `${process.env.REACT_APP_LAWS_ARCHIVE_BACKEND_HOST}/v1/bills/${sessionId}/${id}`
        );
        const { data: sessionData } = await axios.get(
          `${process.env.REACT_APP_LAWS_ARCHIVE_BACKEND_HOST}/v1/sessions`
        );
        const sessionFound = sessionData.find(
          (item) => item.sessionId == sessionId
        );
        const ordinal = sessionFound ? sessionFound.ordinal : 0;
        setBill(billData);
        setOrdinal(ordinal);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchDataAndSetBills();
  }, [sessionId, id]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrintReady = () => {
    setIsPrintReady(true);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isLoading && Object.keys(bill).length === 0) {
    return <div>Failed to load bill details.</div>;
  }

  return (
    <>
      <PreHeader />
      <MDBContainer fluid>
        <MDBRow className="g-1">
          <MDBCol size="lg" className="text-center text-md-start mb-2">
            <h4>
            {bill.billType ? `${bill.billType} ${bill.billNumber}: ${bill.shortTitle}` : id}
            </h4>
          </MDBCol>
          <MDBCol size="auto">
            <MDBBtn onClick={handlePrint} disabled={!isPrintReady}>
              {isPrintReady ? (
                <>
                  <MDBIcon fas icon="print" /> Print
                </>
              ) : (
                <MDBSpinner size="sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </MDBSpinner>
              )}
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <Tabs billDetails={bill} ordinal={ordinal} defaultTab={openTab} />
        <AppBuildVersion />
        <div style={{ display: "none" }}>
          <PrintableBillDetails
            ref={componentRef}
            bill={bill}
            ordinal={ordinal}
            onLoadingComplete={handlePrintReady}
          />
        </div>
      </MDBContainer>
    </>
  );
};

export default BillDetails;
